var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9.5","height":"5.811","viewBox":"0 0 9.5 5.811"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_300","data-name":"Path 300","d":"M222.371,190.871l4-4-4-4","transform":"translate(191.621 -221.621) rotate(90)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }